@if (readyForRouting) {
  <router-outlet></router-outlet>
}
